import { createStyles, Theme, withStyles, Menu, MenuItem, ListItemIcon, ListItemText, IconButton, Avatar, Typography, Divider } from "@material-ui/core";

import LogoutIcon from "@material-ui/icons/SettingsPower";
import DashboardIcon from "@material-ui/icons/Dashboard";

import React from "react";

import i18n from '../../services/localization/i18n';

import config from '../../config';

const styles = (theme: Theme) => createStyles({
    avatar: {
        borderColor: "white",
        borderWidth: 3,
        borderStyle: "solid",
      },
    menu: {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
        borderStyle: "solid"
    },
    menuItem: {

    },
    root: {

    }
})

interface ISignOutProps {
    classes: {
        avatar: string;
        menu: string;
        menuItem: string;
        root: string;
    }
}

interface ISignOutState {
    anchorEl: HTMLElement | null;
}

class SignOut extends React.Component<ISignOutProps, ISignOutState> {

    constructor(props: ISignOutProps) {
        super(props);

        this.state = {
           anchorEl: null 
        }
    }


    public render() {
        const {classes} = this.props;

        if (!config.me) {
            return <div />;
        }

        return  <div className={classes.root}>
                    <IconButton
                            onClick={this.atachMenuToIcon}
                            aria-controls="customized-menu"
                            aria-haspopup="true"
                            color="inherit">

                            <Avatar className={classes!.avatar} 
                                    src={config.me!.avatarUrl} 
                                    title={`${config.me!.firstName} ${config.me!.familyName} (${config.me!.email})`}
                                    style={{
                                        backgroundColor: `${config.me!.color}`
                                    }}>
                                        
                                    <Typography variant="button">
                                        {this.getInitials()}
                                    </Typography>
                                
                            </Avatar>
                    </IconButton>

                    <Menu   id="customized-menu"
                            className={classes.menu}
                            elevation={2}
                            onClose={this.onCloseMenu}
                            keepMounted={true}
                            anchorEl={this.state.anchorEl}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            open={Boolean(this.state.anchorEl)}>

                            <MenuItem onClick={() => window.location.href = "/pro"} className={classes!.menuItem} >
                                <ListItemIcon>
                                    <DashboardIcon />
                                </ListItemIcon>
                                <ListItemText primary={ i18n.t('header_dashboard_text') } />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={this.onLogOut} className={classes!.menuItem} >
                                <ListItemIcon>
                                    <LogoutIcon />
                                </ListItemIcon>
                                <ListItemText primary={ `${i18n.t("signout_menu_text")} (${config.me.email})`} />
                            </MenuItem>
                    </Menu>
                </div>;    
    }


    private onLogOut = () => {
        window.location.href = "/client/logout";
    }

    private onCloseMenu = () => {

        this.setState({
            anchorEl: null
        });
    }

    private atachMenuToIcon = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

        let anchor = event.currentTarget;

            this.setState({
                anchorEl: anchor
            });
    }

    private getInitials() {

        if (!config.me) {
            return "N/A";
        }

        let initials = config.me.firstName.substr(0, 1);
        const lastName = config.me.familyName!.substr(0, 1);
        if (lastName !== "(") {
            initials += lastName;
        }
        return initials;
    }
}

export default withStyles(styles, { withTheme: true })(SignOut);